// App.js
import React from "react";
import "./App.css";
import GDLab from "./components/GdLab/GdLab";
import Login from "./components/Admin/Login";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<GDLab />} />
          <Route path="/admin" element={<Login />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
